import React from 'react';

import { QueryClient, QueryClientProvider } from 'react-query';
import { FloorContextProvider } from './context/FloorContext';
import { SearchContextProvider } from './context/SearchContext';
import { NFTContextProvider } from './context/NFTContext';
import { UserContextProvider } from './context/UserContext';
import { ConfigurationContextProvider } from './context/ConfigurationContext';
import { TargetContextProvider, TargetType } from './context/TargetContext';
import { RoomContextProvider } from './context/RoomContext';

import Main from './Main';
import Header from './components/UI/Header';

function App() {
  const queryClient = new QueryClient();

  return (
    <TargetContextProvider target={process.env.REACT_APP_TARGET as TargetType}>
      <QueryClientProvider client={queryClient}>
        <ConfigurationContextProvider>
          <UserContextProvider>
            <RoomContextProvider>
              <NFTContextProvider>
                <FloorContextProvider>
                  <SearchContextProvider>
                    <Header />
                    <Main />
                  </SearchContextProvider>
                </FloorContextProvider>
              </NFTContextProvider>
            </RoomContextProvider>
          </UserContextProvider>
        </ConfigurationContextProvider>
      </QueryClientProvider>
    </TargetContextProvider>
  );
}

export default App;
